/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
import {getDeliveryDates} from "../api";

export interface Address {
  zip?: string;
  address1: string;
  address2?: string;
  province?: string;
  city?: string;
  country?: string;
  company?: string;
  phone?: string;
  first_name?: string;
  last_name?: string;
  street?: string;
}

export interface Transport {
  deliveryStart: string;
  deliveryEnd: string;
  deliveryDays: string;
  name: string;
  dispatchOffset: number;
}

export const getDeliveryDatesApi = async (zipCode?: string, startDate: string = null, endDate: string = null) => {
  const response = await getDeliveryDates(zipCode, startDate, endDate);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return (await response.json()) as string[];
};
